// import { stringify } from "qs";

import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";
import { stringifyQs } from "../utils/urls";

export const instagramSection = "/instagram/";

export const instagramListPath = instagramSection;

export type InstagramListUrlDialog = "publish" | "unpublish" | TabActionDialog;

export enum InstagramListUrlFiltersEnum {
  query = "query",
  published = "published",
  createdFrom = "createdFrom",
  createdTo = "createdTo"
}
export enum InstagramListUrlFiltersWithMultipleValuesEnum {
  platForm = "platForm"
}

export enum InstagramListUrlSortField {
  name = "name",
  instagramid = "instagramId",
  image = "image",
  createTime = "createTime",
  published = "published",
  istop = "istop",
  shortcode = "shortcode"
}

export type InstagramListUrlFilters = Filters<InstagramListUrlFiltersEnum> &
  FiltersWithMultipleValues<InstagramListUrlFiltersWithMultipleValuesEnum>;

export type InstagramListUrlSort = Sort<InstagramListUrlSortField>;

export type InstagramListUrlQueryParams = ActiveTab &
  BulkAction &
  InstagramListUrlFilters &
  InstagramListUrlSort &
  Dialog<InstagramListUrlDialog> &
  Pagination;

export const instagramListUrl = (params?: InstagramListUrlQueryParams) =>
  instagramListPath + "?" + stringifyQs(params);

export type InstagramUrlDialog =
  | "remove"
  | "assign"
  | "unassignTag"
  | "add-tag"
  | "unassign"
  | "updateTag";

export type InstagramPathUrlQueryParams = BulkAction &
  Dialog<InstagramUrlDialog> &
  SingleAction &
  Pagination;

export const instagramPath = (id: string) => urlJoin(instagramSection, id);

export const instagramUrl = (
  id: string,
  params?: InstagramPathUrlQueryParams
) => instagramPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
